import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft, RefreshCw, Share2, Sparkles } from 'lucide-react';
import { questions, results } from './IdolData';
import KakaoShareButton from './KakaoShareButton';

const IdolTest = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(0); // 0:시작, 1:진행, 2:결과
  const [currentIdx, setCurrentIdx] = useState(0);
  const [scores, setScores] = useState({ E: 0, I: 0, S: 0, N: 0, T: 0, F: 0, J: 0, P: 0 });
  const [mbtiResult, setMbtiResult] = useState("");

  const handleAnswer = (value) => {
    const nextScores = { ...scores, [value]: scores[value] + 1 };
    setScores(nextScores);

    if (currentIdx + 1 < questions.length) {
      setCurrentIdx(currentIdx + 1);
    } else {
      // MBTI 결과 계산
      const res = [
        nextScores.E >= nextScores.I ? "E" : "I",
        nextScores.S >= nextScores.N ? "S" : "N",
        nextScores.T >= nextScores.F ? "T" : "F",
        nextScores.J >= nextScores.P ? "J" : "P"
      ].join("");
      setMbtiResult(res);
      setStep(2);
    }
  };

  return (
    <div className="min-h-screen bg-indigo-50 flex flex-col items-center p-6 font-sans">
      {/* 상단바 */}
      <button onClick={() => navigate('/')} className="self-start mb-6 text-gray-500 flex items-center hover:text-indigo-600 transition-colors">
        <ChevronLeft size={20} /> 홈으로 돌아가기
      </button>

      {/* 1. 시작 화면 */}
      {step === 0 && (
        <div className="max-w-md w-full bg-white rounded-3xl shadow-2xl p-10 text-center border-4 border-indigo-200 mt-10">
          <div className="mb-6 animate-bounce">
            <Sparkles size={80} className="mx-auto text-indigo-500" />
          </div>
          <h1 className="text-4xl font-black text-gray-800 mb-4 tracking-tight">💎 빠순사주</h1>
          <p className="text-indigo-600 font-bold text-lg mb-10 leading-relaxed">나의 덕질 DNA와<br/>숨겨진 성향분석</p>
          <button
            onClick={() => setStep(1)}
            className="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-5 rounded-2xl text-2xl shadow-lg transform transition active:scale-95"
          >
            사주 확인하기
          </button>
        </div>
      )}

      {/* 2. 질문 진행 화면 */}
      {step === 1 && (
        <div className="max-w-md w-full">
          <div className="w-full bg-gray-200 h-3 rounded-full mb-10 overflow-hidden">
            <div className="bg-indigo-500 h-full transition-all duration-500" style={{ width: `${((currentIdx + 1) / questions.length) * 100}%` }}></div>
          </div>
          <div className="bg-white rounded-3xl shadow-xl p-8 border-2 border-indigo-50">
            <p className="text-indigo-400 font-bold mb-4">질문 {currentIdx + 1}</p>
            <h2 className="text-2xl font-bold text-gray-800 mb-10 leading-snug">{questions[currentIdx].text}</h2>
            <div className="space-y-4">
              {questions[currentIdx].answers.map((ans, i) => (
                <button
                  key={i}
                  onClick={() => handleAnswer(ans.value)}
                  className="w-full bg-gray-50 hover:bg-indigo-50 border-2 border-gray-100 hover:border-indigo-300 text-gray-700 font-bold py-5 px-6 rounded-2xl text-lg text-left transition-all leading-snug shadow-sm"
                >
                  {ans.text}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* 3. 결과 화면 */}
      {step === 2 && (
        <div className="max-w-md w-full animate-in fade-in zoom-in duration-500">
          <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border-4 border-white">
            <div className={`p-10 text-center bg-gradient-to-br ${results[mbtiResult].color} text-white`}>
              <p className="font-bold opacity-80 mb-2 text-lg">나의 덕질 사주는...</p>
              <h2 className="text-4xl font-black mb-6 tracking-tight">{results[mbtiResult].name}</h2>
              <div className="text-9xl mb-4 filter drop-shadow-lg">{results[mbtiResult].icon}</div>
            </div>
            
            <div className="p-10 text-center">
              <div className="bg-indigo-50 p-6 rounded-2xl mb-10">
                <p className="text-gray-700 text-xl font-medium leading-relaxed break-keep">
                  "{results[mbtiResult].desc}"
                </p>
              </div>

              {/* 수익화: 관련 굿즈(쿠팡 파트너스 등) 자리를 여기에 만들 수 있습니다 */}
              <div className="bg-yellow-50 border-2 border-yellow-200 rounded-2xl p-4 mb-8 text-sm text-yellow-800">
                ⭐ <strong>추천 아이템:</strong> 최애를 더 선명하게! 망원경/보조배터리 구경하기
              </div>

              <div className="space-y-4">
                <KakaoShareButton 
                  title={`빠순사주 결과: ${results[mbtiResult].name}`}
                  description={results[mbtiResult].desc}
                />
                <div className="flex gap-3">
                  <button onClick={() => window.location.reload()} className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-700 font-bold py-4 rounded-2xl flex items-center justify-center gap-2 transition shadow-sm">
                    <RefreshCw size={20} /> 다시하기
                  </button>
                  <button onClick={() => navigate('/')} className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-700 font-bold py-4 rounded-2xl flex items-center justify-center gap-2 transition shadow-sm">
                    <Share2 size={20} /> 홈으로
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default IdolTest; // 에러 방지용 필수 내보내기!
